import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { FormlyFieldConfig } from "@ngx-formly/core";
import { DocumentDirection } from '../../../../generated/generated-types';

export function addressDocumentExportFallbackFields(): FormlyFieldConfig[] {
    return [
        {

            fieldGroupClassName: 'flex flex-wrap',
            props: {
            },
            fieldGroup: [
                {
                    className: "w-full",
                    fieldGroupClassName: "flex flex-wrap",
                    fieldGroup: [

                        {
                            key: 'documentDefinition',
                            className: "w-full md:w-1/2",
                            type: 'formly-document-definition-dropdown',
                            props: {
                                label: _('address-document-export.document-definition'),
                                translate: true,
                                autoLoad: false,
                                required: true,
                                docDirection: DocumentDirection.OUT,
                                attributes: {
                                    'data-testid': 'formly-address-document-export-document-definition'
                                }
                            },
                        },
                        {
                            key: 'documentTransferFormat',
                            className: "w-full md:w-1/2",
                            wrappers: ["simple-title"],
                            type: 'formly-document-transfer-format-dropdown',
                            expressions: {
                                "props.withoutFinancialFormats": "!model.documentDefinition?.financeRelevant"
                            },
                            props: {
                                label: _('address-document-export.document-transfer-format'),
                                translate: true,
                                autoLoad: false,
                                required: true,
                                onlyFinancialFormats: false,
                                attributes: {
                                    'data-testid': 'formly-address-document-export-document-transfer-format'
                                }
                            }

                        },
                        {
                            key: 'addressContactLink',
                            className: "w-full",
                            wrappers: ["simple-title"],
                            type: 'formly-contact-link-drop-down',
                            props: {
                                label: _('address-document-export.contact'),
                                translate: true,
                                autoLoad: false,
                                withMail: true,
                                placeholder: _('address-document-export.contact-placeholder')
                            }
                        },
                        {
                            key: 'emailAddresses',
                            className: 'w-full',
                            wrappers: ['simple-title'],
                            type: 'textarea',
                            props: {
                                label: _('address-document-export.email-addresses'),
                                rows: 2,
                                required: false,
                                translate: true,
                            }

                        }
                    ],

                },
            ]
        },
    ]
}






